import ModuleConfig from '../Config';
import { toaster } from 'evergreen-ui';

const actions = ModuleConfig.Actions;
const endpoints = ModuleConfig.Endpoints;
const CRUDActions = ModuleConfig.CRUDActions;
const Api = ModuleConfig.Api;
const EventReservation = ModuleConfig.Structures.EventReservation;

export function getEventReservations(opts = { start: 0, limit: 25 }) {
    return CRUDActions.getAll(actions.getAll, {
        ...opts,
        endpoint: endpoints.eventReservations,
        mapStructure: EventReservation,
        errorNotification: "Rezervarile nu au putut fi incarcate"
    });
}

export function getEventReservation(id) {
    return CRUDActions.getOne(actions.getOne, {
        id,
        endpoint: endpoints.eventReservation,
        mapStructure: EventReservation,
        errorNotification: "Rezervarea nu a putut fi incarcata"
    })
}

export function createEventReservation(values) {
    return CRUDActions.create(actions.create, {
        values,
        endpoint: endpoints.eventReservations,
        mapStructure: EventReservation,
        successNotification: "Rezervarea a fost creata",
        nextUrl: '/event-reservations/',
    })
}

export function updateEventReservation(id, values) {
    return CRUDActions.update(actions.edit, {
        id,
        values,
        endpoint: endpoints.eventReservation,
        mapStructure: EventReservation,
        successNotification: "Rezervarea a fost modificata",
        nextUrl: '/event-reservations/',
    })
}

export function deleteEventReservation(id) {
    return CRUDActions.remove(actions.delete, {
        id,
        endpoint: endpoints.eventReservation,
        successNotification: "Rezervarea a fost stearsa",
        nextUrl: '/event-reservations/'
    });
}

export function getEvents() {
    return async (dispatch) => {
        dispatch({ type: actions.getEvents.request.id });
        
        try {
            const response = await Api.get(endpoints.events, { start: 0, limit: 100 });
            
            if (response.success) {
                dispatch({
                    type: actions.getEvents.success.id,
                    options: { data: response.data }
                });
            } else {
                throw new Error(response.message || 'Failed to load events');
            }
        } catch (error) {
            dispatch({ type: actions.getEvents.failure.id });
            toaster.danger("Evenimentele nu au putut fi incarcate");
        }
    };
}

export function getPaymentTypes() {
    return async (dispatch) => {
        dispatch({ type: actions.getPaymentTypes.request.id });
        
        try {
            const response = await Api.get(endpoints.paymentTypes, { start: 0, limit: 100 });
            
            if (response.success) {
                // Filter to only active card_online and card_physical (cash at location)
                const filteredData = response.data.filter(pt => 
                    pt.active && (pt.type === 'card_online' || pt.type === 'card_physical')
                );
                
                dispatch({
                    type: actions.getPaymentTypes.success.id,
                    options: { data: filteredData }
                });
            } else {
                throw new Error(response.message || 'Failed to load payment types');
            }
        } catch (error) {
            dispatch({ type: actions.getPaymentTypes.failure.id });
            toaster.danger("Tipurile de plata nu au putut fi incarcate");
        }
    };
}

export function searchEvents(query) {
    return async (dispatch) => {
        try {
            const response = await Api.get(endpoints.events, { 
                start: 0, 
                limit: 20,
                q: query
            });
            
            if (response.success) {
                return response.data || [];
            }
            return [];
        } catch (error) {
            console.error('Error searching events:', error);
            return [];
        }
    };
}
